import Vue from 'vue';
import VueRouter from 'vue-router';

import { guards, overlayBlock } from '@/services/router-guards';
import { authGuard } from '@/auth/authGuard';

import Main from '@/views/Main';

import Requests from '@/views/Requests';
import Detail from '@/views/Detail';

//import Realisations from '@/views/Realisations';
import Processes from '@/views/Processes';
import Process from '@/views/Process';
import Record from '@/views/processes/Record';
import Realisation from '@/views/Realisation';

import Config from '@/views/Config';
import TagConfigPanel from '@/views/admin/TagConfigPanel.vue';
import PIDConfigPanel from '@/views/admin/PIDConfigPanel.vue';
import ContractorsConfigPanel from '@/views/admin/ContractorsConfigPanel.vue';
import ExportConfigPanel from '@/views/admin/ExportConfigPanel.vue';

// Reporting
import Reporting from '@/views/Reporting';
import KeyMetrics from '@/views/reporting/KeyMetrics';
import RequestAssessment from '@/views/reporting/RequestAssessment';
import RealisationProcessStatus from '@/views/reporting/RealisationProcessStatus';
import ProcessTimeInSteps from '@/views/reporting/ProcessTimeInSteps';
import RVBCustomers from '@/views/reporting/RVBCustomers';
import RVBChargingpointsByObjectType from '@/views/reporting/RVBChargingpointsByObjectType';
import RVBChargingpointsByPID from '@/views/reporting/RVBChargingpointsByPID';
import RVBGridImprovements from '@/views/reporting/RVBGridImprovements';

// Manuals
import Manuals from '@/views/Manuals.vue';
import ManualPage from '@/views/manuals/ManualPage.vue';

// Release Notes
import ReleaseNotes from '@/views/ReleaseNotes.vue';
import ReleaseNotePage from '@/views/release-notes/ReleaseNotePage.vue';

Vue.use(VueRouter);

const routes = [
  /**
   * Realisation process
   */
  {
    path: '/processen/:type?/:filter?',
    name: 'ProcessList',
    component: Processes
  },
  {
    path: '/realisatie/:uuid?',
    name: 'Realisation',
    component: Realisation,
    children: [
      {
        path: '/realisatie/nieuw',
        name: 'NewRealisation',
        component: Realisation
      }
      // the rest of the routes will be dynamically added in App.vue once the steps are loaded from config
    ]
  },
   /**
   * e.g. Addition process // TODO: All processes dynamic load
   */
    // {
    //   path: '/procesen/:filter?',
    //   name: 'ProcessList',
    //   component: Processes
    // },
    {
      path: '/proces/:uuid?',
      name: 'Process',
      component: Process,
      children: [
        {
          path: '/proces/nieuw',
          name: 'NewProcess',
          component: Process
        }
        // the rest of the routes will be dynamically added in App.vue once the steps are loaded from config
      ]
    },
    // Temp. named Record //
    {
      path: '/proces/:uuid?',
      name: 'Record',
      component: Record,
      children: [
        // the rest of the routes will be dynamically added in App.vue once the steps are loaded from config
      ]
    },

  /**
   * Requests
   */
  {
    path: '/aanvragen',
    name: 'RequestList',
    component: Requests
  },
  {
    path: '/aanvragen/:uuid',
    name: 'RequestDetail',
    component: Detail
  },

  /**
   * Config
   */
  {
    path: '/beheer',
    name: 'Config',
    component: Config,
    children: [
      {
        path: 'tags',
        name: 'TagsConfig',
        component: TagConfigPanel
      },
      {
        path: 'pids',
        name: 'PidsConfig',
        component: PIDConfigPanel
      },
      {
        path: 'contractors',
        name: 'ContractorsConfig',
        component: ContractorsConfigPanel
      },
      {
        path: 'exports',
        name: 'ExportConfig',
        component: ExportConfigPanel
      }
    ]
  },

  /**
   *
   */
  {
    path: '/rapportage',
    name: 'Reporting',
    component: Reporting,
    children: [
      {
        path: 'key-metrics',
        name: 'KeyMetrics',
        component: KeyMetrics
      },
      {
        path: 'beoordelingen',
        name: 'RequestAssessment',
        component: RequestAssessment
      },
      {
        path: 'realisatiestatus',
        name: 'RealisationProcessStatus',
        component: RealisationProcessStatus
      },
      {
        path: 'procesdoorlooptijden',
        name: 'ProcessTimeInSteps',
        component: ProcessTimeInSteps
      },
      {
        path: 'klanten',
        name: 'RVBCustomers',
        component: RVBCustomers
      },
      {
        path: 'laadpunten-per-stelsel',
        name: 'RVBChargingpointsByObjectType',
        component: RVBChargingpointsByObjectType
      },
      {
        path: 'laadpunten-per-pid',
        name: 'RVBChargingpointsByPID',
        component: RVBChargingpointsByPID
      },
      {
        path: 'aantal-netverzwaringen',
        name: 'RVBGridImprovements',
        component: RVBGridImprovements
      },
    ]
  },

  /**
   * Manual pages
   */
  {
    path: '/handleidingen',
    name: 'Manuals',
    component: Manuals,
    children: [
      {
        path: ':id',
        name: 'ManualPage',
        component: ManualPage
      }
    ]
  },

    {
    path: '/release-notes',
    name: 'ReleaseNotes',
    component: ReleaseNotes,
    children: [
      {
        path: ':uuid',
        name: 'ReleaseNotePage',
        component: ReleaseNotePage
      }
    ]
  },

  /**
   * Main - currently redirects to RequestList or RealisationList based on role
   */
  {
    path: '/',
    name: 'Dashboard',
    component: Main
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    window.scrollTo(0, 0);
  },
  linkActiveClass: 'active',
  linkExactActiveClass: 'active exact-active'
});

router.beforeEach(guards([authGuard, overlayBlock({ Vue })]));

router.beforeEach((to, from, next) => {
  // Set page title
  if (process.env.VUE_APP_WORKFLOW_TITLE) {
    document.title = process.env.VUE_APP_WORKFLOW_TITLE;
  }
  next();
});


export default router;
